module.exports = __webpack_public_path__ + "img/slider-bg2.64368a44.jpg";